import { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { HttpStatusCode } from '../common/enums';
import { GenericApiResponse } from '../models/generic/generic-api-response';
import Vue from 'vue';
export class AxiosHelper {

  public static isExpired: boolean = false;
  public static statusValidator(status: number) {
    return status >= 200 && status <= 503;
  }

  public static interceptorRequest(request: AxiosRequestConfig) {
    return request;
  }
  public static interceptorResponse(response: AxiosResponse, vm) {
    switch (response.status) {
      case HttpStatusCode.UnAuthorized:
        response.data = new GenericApiResponse(false, { ...response.data })
        break;
      case HttpStatusCode.BadRequest:
        response.data = new GenericApiResponse(false, { ...response.data })
        break;
      case HttpStatusCode.OK:
      case HttpStatusCode.Created:
        response.data = new GenericApiResponse(true, { data: response.data })
        break;
      default:
        response.data = new GenericApiResponse(false, { ...response.data || response.statusText })
        break;
    }
    return response;
  }
  public static handleException(exception: AxiosHelper, cb) {
    cb({
      isSuccess: false,
      error: exception
    });
    return exception;
  }
}


// WEBPACK FOOTER //
// ./src/utils/AxiosHelper.util.ts